import { c as _c } from "react/compiler-runtime";
import React, { FC, SVGProps } from 'react';
export const Minus: FC<SVGProps<SVGSVGElement>> = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="title=remove"><path id="Stroke 2" d="M16.0723 7.992L1.92578 7.9905" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg {...props} fill="none" stroke="currentColor" width="17" height="16" viewBox="0 0 17 16" xmlns="http://www.w3.org/2000/svg">{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};